import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { NEVER, Observable } from 'rxjs';
import { request } from 'express';

@Injectable()
export class HttpRemoveForcedParametersInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      httpRequest.url.includes('/configuration/tracking/googleTagManager') ||
      httpRequest.url.includes('/configuration/tracking/googleAnalytics') ||
      httpRequest.url.includes('/configuration/tracking/facebookPixel')
    ) {
      return next.handle(
        httpRequest.clone({
          url: httpRequest.url.split('?')[0],
          params: httpRequest.params.delete('curr').delete('lang'),
        })
      );
    }
    if (httpRequest.url.includes('/categories/cx-preview')) {
      return NEVER;
    }

    return next.handle(httpRequest);
  }
}
